import React from 'react'
import { ILayoutProps, LayoutContainer } from 'common-components'
import styled from '@emotion/styled'

type IPageContainerProps = ILayoutProps

const StyledLayoutContainer = styled(LayoutContainer)`
  max-width: 1216px;
  margin: auto;
`

export const PageContainer = function ({ children, ...rest }: IPageContainerProps) {
  return (
    <StyledLayoutContainer theme={'light'} {...rest}>
      {children}
    </StyledLayoutContainer>
  )
}
